<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-tit">I<span class="small">NTRODUCTION</span></p>
<p class="noindent">During the years of the Civil War, Colorado was embroiled in its own battle: the struggle between the increasing waves of white settlers and the tribes who lived in the region. Both sides were deeply divided within themselves—some worked tirelessly to find a way to coexist peacefully; others wanted total war. At a moment when the peacemakers thought they had found a way forward, those who preferred the violent solution intervened.</p>
<p class="indent">These are the stories of fourteen people whose lives intersected over the most infamous event in Colorado history: the massacre of Cheyenne and Arapaho Indians at Sand Creek.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// introduction.vue?db471f36